// src/v3/account/security.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var SecurityIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "SecurityIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M19.5 3.75H4.5C4.10218 3.75 3.72064 3.90804 3.43934 4.18934C3.15804 4.47064 3 4.85218 3 5.25V10.7597C3 19.1606 10.1081 21.9478 11.5312 22.4212C11.8352 22.5246 12.1648 22.5246 12.4688 22.4212C13.8937 21.9478 21 19.1606 21 10.7597V5.25C21 4.85218 20.842 4.47064 20.5607 4.18934C20.2794 3.90804 19.8978 3.75 19.5 3.75ZM19.5 10.7616C19.5 18.1134 13.2797 20.5697 12 20.9972C10.7316 20.5744 4.5 18.12 4.5 10.7616V5.25H19.5V10.7616Z"
  }
) });

export {
  SecurityIcon
};
